
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dealer/[...id]",
      function () {
        return require("private-next-pages/dealer/[...id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dealer/[...id]"])
      });
    }
  